import memoize from './memoize';

/**
 * Splits a property path into parts.
 * @function splitPath
 * @private
 * @param {string} path String path to split into parts.
 * @return {Array<(string)>} An array of path parts.
 */
const splitPathMemoized = memoize(
	function splitPath(path) {
		if (typeof path !== 'string' && !Array.isArray(path)) return [];

		if (Array.isArray(path)) return path;

		const keys = path.split('.');

		for (let i = 0; i < keys.length; i++) {
			const part = keys[i];
			const {length: partLength} = part;
			if (part.charAt(partLength - 1) === ']') {
				const index = [];
				let char = '[';
				let indexStartPosition = part.indexOf(char);
				const key = part.substring(0, indexStartPosition);

				if (key)
					// key will be empty for `[0].bar`
					index.push(key);

				while (indexStartPosition < partLength) {
					if (char !== '[' && char !== ']') {
						const indexEndPosition = part.indexOf(']', indexStartPosition);
						let arrayPart = part.substring(indexStartPosition, indexEndPosition);

						// If the part inside the array access is wrapped in quotes, remove them
						if (
							arrayPart.charAt(0) === arrayPart.charAt(arrayPart.length - 1) &&
							["'", '"'].includes(arrayPart.charAt(0))
						)
							arrayPart = arrayPart.slice(1, -1);

						index.push(arrayPart); // this could be [0] or [foo]
						indexStartPosition = indexEndPosition;
					} else {
						indexStartPosition += 1;
					}

					char = part.charAt(indexStartPosition);
				}

				const {length: indexLength} = index;
				if (indexLength) {
					keys.splice(i, 1, ...index);
					i += indexLength - 1;
				}
			}
		}

		return keys;
	},
	null,
	{profileName: 'splitPath'}
);

export {splitPathMemoized as splitPath};
